export function toggleValue<T>(value: T, values: T[]): void {
  const index = values.indexOf(value);
  index < 0 ? values.push(value) : values.splice(index, 1);
}
